/**
 * AI assistant Rive character — single swap point for the real asset.
 *
 * The character .riv is NOT in public/riv/ yet (current files there are
 * scene animations). When it lands:
 *   1. set AI_CHARACTER_RIV to its filename (without .riv),
 *   2. set AI_CHARACTER_STATE_MACHINE / AI_CHARACTER_BOOL_INPUTS to the
 *      names exported by the asset (missing inputs are tolerated — the
 *      state machine then just autoplays),
 *   3. flip AI_CHARACTER_ENABLED to true.
 * Until then every consumer falls back to its icon (sparkles / spinner).
 */
export const AI_CHARACTER_ENABLED: boolean = false;

export const AI_CHARACTER_RIV = "AiAssistantCharacter";

/**
 * Scene .riv shown in the chat EMPTY STATE hero (the app's convention: empty
 * tables render scene animations the same way — see TableBody). Autoplay loop
 * via VideoPlayerRiv. Swap to any file in public/riv/ (without .riv). Falls
 * back to the static AiOrb under reduced-motion. Once the real character lands
 * (AI_CHARACTER_ENABLED), that takes precedence over this scene.
 */
export const AI_EMPTY_STATE_RIV = "CreatingEvent";

export const AI_CHARACTER_STATE_MACHINE = "State Machine 1";

/** Boolean state-machine inputs driven by chat state; null name = not wired. */
export const AI_CHARACTER_BOOL_INPUTS: { thinking: string | null; talking: string | null } = {
  thinking: "thinking",
  talking: "talking",
};
